import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Image as ImageIcon, Users, Heart, User as UserIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

function MobileTabBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, isArtist, profiles } = useAuth();

  const accountHref = !isAuthenticated
    ? '/login'
    : isAdmin
    ? '/admin'
    : profiles?.role === 'lead_chitrakar'
    ? '/lead-chitrakar'
    : profiles?.role === 'kalakar'
    ? '/kalakar'
    : isArtist
    ? '/dashboard'
    : '/user-dashboard';

  const tabs = [
    { label: 'Home', href: '/', Icon: Home },
    { label: 'Art', href: '/paintings', Icon: ImageIcon },
    { label: 'Artists', href: '/artists', Icon: Users },
    { label: 'Community', href: '/communities', Icon: Heart },
    { label: 'Account', href: accountHref, Icon: UserIcon },
  ];

  const isActive = (href) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-cream-100/95 backdrop-blur-md border-t border-gold-500/20"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-tab-bar"
    >
      <div className="grid grid-cols-5">
        {tabs.map(({ label, href, Icon }) => {
          const active = isActive(href);
          return (
            <button
              key={label}
              onClick={() => navigate(href)}
              className="flex flex-col items-center justify-center gap-1 py-2.5 transition-colors"
              data-testid={`tab-${label.toLowerCase()}`}
            >
              <Icon
                className={`w-[22px] h-[22px] ${active ? 'text-gold-600' : 'text-navy-500'}`}
                strokeWidth={active ? 2 : 1.6}
              />
              <span className={`text-[10px] font-medium tracking-wide ${active ? 'text-gold-700' : 'text-navy-400'}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileTabBar;
